const Header = () => (
  <header 
    className="py-5" 
    style={{ 
      background: "linear-gradient(135deg, #f8f9fa, #e9ecef)" 
    }}
  >
    <div className="container text-center">
      <h1 
        className="display-4 fw-bold" 
        style={{ fontFamily: "'Poppins', sans-serif", color: "#212529" }}
      >
        Market Luz
      </h1>
      <p 
        className="lead fw-normal" 
        style={{ fontFamily: "'Poppins', sans-serif", color: "#0d6efd" }}
      >
        Todo lo que necesitas en un solo lugar...
      </p>
    </div>
  </header>
);

export default Header;
